// Simple i18n system - no external dependencies
import React from 'react';

// Supported languages
export const LANGUAGES = [
  { code: 'en', name: 'English',  flag: '🇬🇧' },
  { code: 'hi', name: 'हिंदी',     flag: '🇮🇳' },
  { code: 'te', name: 'తెలుగు',    flag: '🇮🇳' },
  { code: 'ta', name: 'தமிழ்',     flag: '🇮🇳' },
  { code: 'kn', name: 'ಕನ್ನಡ',     flag: '🇮🇳' },
  { code: 'mr', name: 'मराठी',     flag: '🇮🇳' },
  { code: 'bn', name: 'বাংলা',     flag: '🇮🇳' },
];

// Translation dictionaries
const translations = {
  en: {
    // Common
    'home': 'Home',
    'wallet': 'Wallet',
    'explore': 'Explore',
    'trade': 'Trade',
    'me': 'Me',
    'back': 'Back',
    'next': 'Next',
    'save': 'Save',
    'cancel': 'Cancel',
    'confirm': 'Confirm',
    'submit': 'Submit',
    'search': 'Search',
    'loading': 'Loading...',
    'success': 'Success!',
    'error': 'Error',
    
    // Home
    'good_morning': 'Good morning',
    'good_afternoon': 'Good afternoon',
    'good_evening': 'Good evening',
    'txc_balance': 'TXC Balance',
    'send': 'Send',
    'receive': 'Receive',
    'quick_actions': 'Quick Actions',
    
    // Profile
    'my_business': 'My Business',
    'my_orders': 'My Orders',
    'settings': 'Settings',
    'overview': 'Overview',
    'logout': 'Log out',
    'language': 'Language',
    'theme': 'Theme',
    'notifications': 'Notifications',
    'email_preferences': 'Email Preferences',
    
    // Auth
    'login': 'Log in',
    'register': 'Register',
    'email': 'Email',
    'password': 'Password',
    'username': 'Username',
    'forgot_password': 'Forgot password?',
    
    // Marketplace
    'browse_services': 'Browse Services',
    'post_request': 'Post Request',
    'my_requests': 'My Requests',
    'quotes_received': 'Quotes Received',
    'start_business': 'Start New Business',
    'analytics': 'Analytics',
    'tier': 'Tier',
    
    // Status
    'pending': 'Pending',
    'accepted': 'Accepted',
    'in_progress': 'In Progress',
    'completed': 'Completed',
    'cancelled': 'Cancelled',
    
    // Chat
    'send_message': 'Send a message',
    'type_message': 'Type a message...',
    
    // Reviews
    'leave_review': 'Leave Review',
    'rate_this_provider': 'Rate this provider',
    
    // Common actions
    'tap_to_rate': 'Tap to rate',
    // Phase 1-6 + extras
    'training_center': 'Training Center',
    'investment_marketplace': 'Investment Marketplace',
    'country_partner': 'Country Partner',
    'vgo_store': 'VGO Store',
    'analytics': 'Analytics',
    'opportunities': 'Opportunities',
    'products': 'Products',
    'orders': 'Orders',
    'investment': 'Investment',
    'enroll': 'Enroll',
    'enrolled': 'Enrolled',
    'completed': 'Completed',
    'in_progress': 'In Progress',
    'certificates': 'Certificates',
    'lessons': 'Lessons',
    'quiz': 'Quiz',
    'take_quiz': 'Take Quiz',
    'mark_complete': 'Mark Complete',
    'required': 'Required',
    'apply_now': 'Apply Now',
    'invest': 'Invest',
    'browse': 'Browse',
    'my_investments': 'My Investments',
    'enable_push': 'Enable Push',
    'push_enabled': 'Push Notifications Enabled',
    'recommendations': 'Recommendations',
    'place_order': 'Place Order',
    'add_address': 'Add Address',
    'low_stock': 'Low Stock',
    'pending_orders': 'Pending Orders',

    // Phase 1-6 + extras
    'training_center': 'Training Center',
    'investment_marketplace': 'Investment Marketplace',
    'country_partner': 'Country Partner',
    'vgo_store': 'VGO Store',
    'analytics': 'Analytics',
    'opportunities': 'Opportunities',
    'products': 'Products',
    'orders': 'Orders',
    'investment': 'Investment',
    'enroll': 'Enroll',
    'enrolled': 'Enrolled',
    'completed': 'Completed',
    'in_progress': 'In Progress',
    'certificates': 'Certificates',
    'lessons': 'Lessons',
    'quiz': 'Quiz',
    'take_quiz': 'Take Quiz',
    'mark_complete': 'Mark Complete',
    'required': 'Required',
    'apply_now': 'Apply Now',
    'invest': 'Invest',
    'browse': 'Browse',
    'my_investments': 'My Investments',
    'enable_push': 'Enable Push',
    'push_enabled': 'Push Notifications Enabled',
    'recommendations': 'Recommendations',
    'place_order': 'Place Order',
    'add_address': 'Add Address',
    'low_stock': 'Low Stock',
    'pending_orders': 'Pending Orders',

  },
  
  hi: {
    'home': 'होम',
    'wallet': 'वॉलेट',
    'explore': 'खोजें',
    'trade': 'ट्रेड',
    'me': 'मैं',
    'back': 'वापस',
    'next': 'आगे',
    'save': 'सहेजें',
    'cancel': 'रद्द करें',
    'confirm': 'पुष्टि करें',
    'submit': 'जमा करें',
    'search': 'खोज',
    'loading': 'लोड हो रहा है...',
    'success': 'सफल!',
    'error': 'त्रुटि',
    'good_morning': 'सुप्रभात',
    'good_afternoon': 'शुभ दोपहर',
    'good_evening': 'शुभ संध्या',
    'txc_balance': 'TXC शेष',
    'send': 'भेजें',
    'receive': 'प्राप्त करें',
    'quick_actions': 'त्वरित कार्य',
    'my_business': 'मेरा व्यवसाय',
    'my_orders': 'मेरे ऑर्डर',
    'settings': 'सेटिंग्स',
    'overview': 'अवलोकन',
    'logout': 'लॉग आउट',
    'language': 'भाषा',
    'theme': 'थीम',
    'notifications': 'सूचनाएं',
    'email_preferences': 'ईमेल प्राथमिकताएं',
    'login': 'लॉग इन',
    'register': 'पंजीकरण',
    'email': 'ईमेल',
    'password': 'पासवर्ड',
    'username': 'यूज़रनेम',
    'forgot_password': 'पासवर्ड भूल गए?',
    'browse_services': 'सेवाएं ब्राउज़ करें',
    'post_request': 'अनुरोध पोस्ट करें',
    'my_requests': 'मेरे अनुरोध',
    'quotes_received': 'प्राप्त कोट्स',
    'start_business': 'नया व्यवसाय शुरू करें',
    'analytics': 'विश्लेषण',
    'tier': 'स्तर',
    'pending': 'लंबित',
    'accepted': 'स्वीकृत',
    'in_progress': 'प्रगति में',
    'completed': 'पूर्ण',
    'cancelled': 'रद्द',
    'send_message': 'संदेश भेजें',
    'type_message': 'संदेश लिखें...',
    'leave_review': 'समीक्षा दें',
    'rate_this_provider': 'इस प्रदाता को रेट करें',
    'tap_to_rate': 'रेट करने के लिए टैप करें',
    // Phase 1-6 + extras
    'training_center': 'ट्रेनिंग सेंटर',
    'investment_marketplace': 'निवेश बाज़ार',
    'country_partner': 'देश साझेदार',
    'vgo_store': 'VGO स्टोर',
    'analytics': 'विश्लेषण',
    'opportunities': 'अवसर',
    'products': 'उत्पाद',
    'orders': 'ऑर्डर',
    'investment': 'निवेश',
    'enroll': 'नामांकन करें',
    'enrolled': 'नामांकित',
    'completed': 'पूर्ण',
    'in_progress': 'प्रगति में',
    'certificates': 'प्रमाणपत्र',
    'lessons': 'पाठ',
    'quiz': 'क्विज़',
    'take_quiz': 'क्विज़ लें',
    'mark_complete': 'पूर्ण चिह्नित करें',
    'required': 'आवश्यक',
    'apply_now': 'अभी आवेदन करें',
    'invest': 'निवेश करें',
    'browse': 'ब्राउज़ करें',
    'my_investments': 'मेरे निवेश',
    'enable_push': 'पुश सक्षम करें',
    'push_enabled': 'पुश सूचनाएं सक्षम',
    'recommendations': 'सिफारिशें',
    'place_order': 'ऑर्डर दें',
    'add_address': 'पता जोड़ें',
    'low_stock': 'कम स्टॉक',
    'pending_orders': 'लंबित ऑर्डर',

    // Phase 1-6 + extras
    'training_center': 'ट्रेनिंग सेंटर',
    'investment_marketplace': 'निवेश बाज़ार',
    'country_partner': 'देश साझेदार',
    'vgo_store': 'VGO स्टोर',
    'analytics': 'विश्लेषण',
    'opportunities': 'अवसर',
    'products': 'उत्पाद',
    'orders': 'ऑर्डर',
    'investment': 'निवेश',
    'enroll': 'नामांकन करें',
    'enrolled': 'नामांकित',
    'completed': 'पूर्ण',
    'in_progress': 'प्रगति में',
    'certificates': 'प्रमाणपत्र',
    'lessons': 'पाठ',
    'quiz': 'क्विज़',
    'take_quiz': 'क्विज़ लें',
    'mark_complete': 'पूर्ण चिह्नित करें',
    'required': 'आवश्यक',
    'apply_now': 'अभी आवेदन करें',
    'invest': 'निवेश करें',
    'browse': 'ब्राउज़ करें',
    'my_investments': 'मेरे निवेश',
    'enable_push': 'पुश सक्षम करें',
    'push_enabled': 'पुश सूचनाएं सक्षम',
    'recommendations': 'सिफारिशें',
    'place_order': 'ऑर्डर दें',
    'add_address': 'पता जोड़ें',
    'low_stock': 'कम स्टॉक',
    'pending_orders': 'लंबित ऑर्डर',

  },
  
  te: {
    'home': 'హోమ్',
    'wallet': 'వాలెట్',
    'explore': 'అన్వేషించు',
    'trade': 'ట్రేడ్',
    'me': 'నేను',
    'back': 'వెనుకకు',
    'next': 'తరువాత',
    'save': 'సేవ్',
    'cancel': 'రద్దు',
    'confirm': 'నిర్ధారించు',
    'submit': 'సమర్పించు',
    'search': 'వెతకండి',
    'loading': 'లోడ్ అవుతోంది...',
    'success': 'విజయం!',
    'error': 'లోపం',
    'good_morning': 'శుభోదయం',
    'good_afternoon': 'శుభ మధ్యాహ్నం',
    'good_evening': 'శుభ సాయంత్రం',
    'txc_balance': 'TXC బ్యాలెన్స్',
    'send': 'పంపండి',
    'receive': 'స్వీకరించండి',
    'quick_actions': 'శీఘ్ర చర్యలు',
    'my_business': 'నా వ్యాపారం',
    'my_orders': 'నా ఆర్డర్లు',
    'settings': 'సెట్టింగులు',
    'overview': 'అవలోకన',
    'logout': 'లాగ్ అవుట్',
    'language': 'భాష',
    'theme': 'థీమ్',
    'notifications': 'నోటిఫికేషన్లు',
    'email_preferences': 'ఇమెయిల్ ప్రాధాన్యతలు',
    'login': 'లాగిన్',
    'register': 'నమోదు',
    'email': 'ఇమెయిల్',
    'password': 'పాస్‌వర్డ్',
    'username': 'యూజర్‌నేమ్',
    'forgot_password': 'పాస్‌వర్డ్ మరిచిపోయారా?',
    'browse_services': 'సేవలను బ్రౌజ్ చేయండి',
    'post_request': 'అభ్యర్థన పోస్ట్ చేయండి',
    'my_requests': 'నా అభ్యర్థనలు',
    'quotes_received': 'అందిన కోట్స్',
    'start_business': 'కొత్త వ్యాపారం ప్రారంభించండి',
    'analytics': 'విశ్లేషణ',
    'tier': 'స్థాయి',
    'pending': 'పెండింగ్',
    'accepted': 'ఆమోదించబడింది',
    'in_progress': 'పురోగతిలో',
    'completed': 'పూర్తయింది',
    'cancelled': 'రద్దు చేయబడింది',
    'send_message': 'సందేశం పంపండి',
    'type_message': 'సందేశం టైప్ చేయండి...',
    'leave_review': 'సమీక్ష ఇవ్వండి',
    'rate_this_provider': 'ఈ సేవా ప్రదాతను రేట్ చేయండి',
    'tap_to_rate': 'రేట్ చేయడానికి ట్యాప్ చేయండి',
    // Phase 1-6 + extras
    'training_center': 'శిక్షణ కేంద్రం',
    'investment_marketplace': 'పెట్టుబడి మార్కెట్',
    'country_partner': 'దేశ భాగస్వామి',
    'vgo_store': 'VGO స్టోర్',
    'analytics': 'విశ్లేషణలు',
    'opportunities': 'అవకాశాలు',
    'products': 'ఉత్పత్తులు',
    'orders': 'ఆర్డర్లు',
    'investment': 'పెట్టుబడి',
    'enroll': 'నమోదు చేసుకోండి',
    'enrolled': 'నమోదు చేసుకున్నారు',
    'completed': 'పూర్తయింది',
    'in_progress': 'ప్రగతిలో',
    'certificates': 'ధృవపత్రాలు',
    'lessons': 'పాఠాలు',
    'quiz': 'క్విజ్',
    'take_quiz': 'క్విజ్ తీసుకోండి',
    'mark_complete': 'పూర్తి అని గుర్తించండి',
    'required': 'అవసరం',
    'apply_now': 'ఇప్పుడు దరఖాస్తు చేయండి',
    'invest': 'పెట్టుబడి పెట్టండి',
    'browse': 'బ్రౌజ్ చేయండి',
    'my_investments': 'నా పెట్టుబడులు',
    'enable_push': 'పుష్ ప్రారంభించండి',
    'push_enabled': 'పుష్ నోటిఫికేషన్‌లు ప్రారంభించబడ్డాయి',
    'recommendations': 'సిఫార్సులు',
    'place_order': 'ఆర్డర్ చేయండి',
    'add_address': 'చిరునామా జోడించండి',
    'low_stock': 'తక్కువ స్టాక్',
    'pending_orders': 'పెండింగ్ ఆర్డర్లు',

    // Phase 1-6 + extras
    'training_center': 'శిక్షణ కేంద్రం',
    'investment_marketplace': 'పెట్టుబడి మార్కెట్',
    'country_partner': 'దేశ భాగస్వామి',
    'vgo_store': 'VGO స్టోర్',
    'analytics': 'విశ్లేషణలు',
    'opportunities': 'అవకాశాలు',
    'products': 'ఉత్పత్తులు',
    'orders': 'ఆర్డర్లు',
    'investment': 'పెట్టుబడి',
    'enroll': 'నమోదు చేసుకోండి',
    'enrolled': 'నమోదు చేసుకున్నారు',
    'completed': 'పూర్తయింది',
    'in_progress': 'ప్రగతిలో',
    'certificates': 'ధృవపత్రాలు',
    'lessons': 'పాఠాలు',
    'quiz': 'క్విజ్',
    'take_quiz': 'క్విజ్ తీసుకోండి',
    'mark_complete': 'పూర్తి అని గుర్తించండి',
    'required': 'అవసరం',
    'apply_now': 'ఇప్పుడు దరఖాస్తు చేయండి',
    'invest': 'పెట్టుబడి పెట్టండి',
    'browse': 'బ్రౌజ్ చేయండి',
    'my_investments': 'నా పెట్టుబడులు',
    'enable_push': 'పుష్ ప్రారంభించండి',
    'push_enabled': 'పుష్ నోటిఫికేషన్‌లు ప్రారంభించబడ్డాయి',
    'recommendations': 'సిఫార్సులు',
    'place_order': 'ఆర్డర్ చేయండి',
    'add_address': 'చిరునామా జోడించండి',
    'low_stock': 'తక్కువ స్టాక్',
    'pending_orders': 'పెండింగ్ ఆర్డర్లు',

  },
  
  ta: {
    'home': 'வீடு',
    'wallet': 'பணப்பை',
    'explore': 'ஆராயுங்கள்',
    'trade': 'வியாபாரம்',
    'me': 'நான்',
    'back': 'பின்',
    'next': 'அடுத்த',
    'save': 'சேமி',
    'cancel': 'ரத்து',
    'confirm': 'உறுதிப்படுத்து',
    'submit': 'சமர்ப்பி',
    'search': 'தேடு',
    'loading': 'ஏற்றப்படுகிறது...',
    'success': 'வெற்றி!',
    'error': 'பிழை',
    'good_morning': 'காலை வணக்கம்',
    'good_afternoon': 'மதிய வணக்கம்',
    'good_evening': 'மாலை வணக்கம்',
    'txc_balance': 'TXC இருப்பு',
    'send': 'அனுப்பு',
    'receive': 'பெறு',
    'quick_actions': 'விரைவு செயல்கள்',
    'my_business': 'என் வணிகம்',
    'my_orders': 'என் ஆர்டர்கள்',
    'settings': 'அமைப்புகள்',
    'overview': 'மேலோட்டம்',
    'logout': 'வெளியேறு',
    'language': 'மொழி',
    'theme': 'தீம்',
    'notifications': 'அறிவிப்புகள்',
    'login': 'உள்நுழைய',
    'register': 'பதிவு செய்',
  },
  
  kn: {
    'home': 'ಮನೆ',
    'wallet': 'ಪರ್ಸ್',
    'explore': 'ಅನ್ವೇಷಿಸಿ',
    'trade': 'ವ್ಯಾಪಾರ',
    'me': 'ನಾನು',
    'back': 'ಹಿಂದೆ',
    'save': 'ಉಳಿಸಿ',
    'cancel': 'ರದ್ದುಮಾಡಿ',
    'search': 'ಹುಡುಕಿ',
    'good_morning': 'ಶುಭೋದಯ',
    'txc_balance': 'TXC ಬಾಕಿ',
    'send': 'ಕಳುಹಿಸಿ',
    'my_business': 'ನನ್ನ ವ್ಯಾಪಾರ',
    'my_orders': 'ನನ್ನ ಆದೇಶಗಳು',
    'settings': 'ಸೆಟ್ಟಿಂಗ್‌ಗಳು',
    'language': 'ಭಾಷೆ',
    'login': 'ಲಾಗಿನ್',
  },
  
  mr: {
    'home': 'मुख्यपृष्ठ',
    'wallet': 'वॉलेट',
    'explore': 'एक्सप्लोर',
    'me': 'मी',
    'back': 'मागे',
    'save': 'जतन करा',
    'cancel': 'रद्द करा',
    'search': 'शोधा',
    'good_morning': 'सुप्रभात',
    'txc_balance': 'TXC शिल्लक',
    'send': 'पाठवा',
    'my_business': 'माझा व्यवसाय',
    'my_orders': 'माझ्या ऑर्डर',
    'settings': 'सेटिंग्ज',
    'language': 'भाषा',
    'login': 'लॉग इन',
  },
  
  bn: {
    'home': 'হোম',
    'wallet': 'ওয়ালেট',
    'explore': 'অন্বেষণ',
    'me': 'আমি',
    'back': 'পিছনে',
    'save': 'সংরক্ষণ',
    'cancel': 'বাতিল',
    'search': 'অনুসন্ধান',
    'good_morning': 'শুভ সকাল',
    'txc_balance': 'TXC ব্যালেন্স',
    'send': 'পাঠান',
    'my_business': 'আমার ব্যবসা',
    'my_orders': 'আমার অর্ডার',
    'settings': 'সেটিংস',
    'language': 'ভাষা',
    'login': 'লগ ইন',
  },
};

// Context for React
const LanguageContext = React.createContext({ lang: 'en', setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLang] = React.useState(() => {
    try { return localStorage.getItem('vgo.lang') || 'en'; } catch { return 'en'; }
  });

  React.useEffect(() => {
    try { localStorage.setItem('vgo.lang', lang); } catch {}
    // Set HTML lang attribute
    document.documentElement.setAttribute('lang', lang);
  }, [lang]);

  return React.createElement(
    LanguageContext.Provider,
    { value: { lang, setLang } },
    children
  );
}

// Hook for translations
export function useT() {
  const { lang } = React.useContext(LanguageContext);
  
  return React.useCallback((key) => {
    return translations[lang]?.[key] || translations.en[key] || key;
  }, [lang]);
}

// Hook for language switching
export function useLang() {
  return React.useContext(LanguageContext);
}

// Direct translation (non-hook)
export function t(key, lang) {
  const l = lang || (typeof localStorage !== 'undefined' ? localStorage.getItem('vgo.lang') : null) || 'en';
  return translations[l]?.[key] || translations.en[key] || key;
}
